"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Tapis Jobs API
 * The Tapis Jobs API executes jobs on Tapis systems.
 *
 * The version of the OpenAPI document: 0.1
 * Contact: cicsupport@tacc.utexas.edu
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var runtime = require("../runtime");
var models_1 = require("../models");
/**
 *
 */
var JobsApi = /** @class */ (function (_super) {
    __extends(JobsApi, _super);
    function JobsApi() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Cancel a previously submitted job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.cancelJobRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.jobUuid === null || requestParameters.jobUuid === undefined) {
                            throw new runtime.RequiredError('jobUuid', 'Required parameter requestParameters.jobUuid was null or undefined when calling cancelJob.');
                        }
                        queryParameters = {};
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/{jobUuid}/cancel".replace("{" + "jobUuid" + "}", encodeURIComponent(String(requestParameters.jobUuid))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespCancelJobFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Cancel a previously submitted job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.cancelJob = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.cancelJobRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve a previously submitted job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.jobUuid === null || requestParameters.jobUuid === undefined) {
                            throw new runtime.RequiredError('jobUuid', 'Required parameter requestParameters.jobUuid was null or undefined when calling getJob.');
                        }
                        queryParameters = {};
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/{jobUuid}".replace("{" + "jobUuid" + "}", encodeURIComponent(String(requestParameters.jobUuid))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespGetJobFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve a previously submitted job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJob = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJobRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve history of a previously submitted job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobHistoryRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.jobUuid === null || requestParameters.jobUuid === undefined) {
                            throw new runtime.RequiredError('jobUuid', 'Required parameter requestParameters.jobUuid was null or undefined when calling getJobHistory.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/{jobUuid}/history".replace("{" + "jobUuid" + "}", encodeURIComponent(String(requestParameters.jobUuid))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespJobHistoryFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve history of a previously submitted job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobHistory = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJobHistoryRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve list of jobs for the user.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobListRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.startAfter !== undefined) {
                            queryParameters['startAfter'] = requestParameters.startAfter;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.computeTotal !== undefined) {
                            queryParameters['computeTotal'] = requestParameters.computeTotal;
                        }
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/list",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespGetJobListFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve list of jobs for the user.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobList = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJobListRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Download job\'s output files for previously submitted job by its UUID. The job must be in a terminal state - FINISHED or FAILED.    The caller must be the job owner, creator or a tenant administrator. The URL must ends with \'/\' even if there is no outputPath is specified.
     */
    JobsApi.prototype.getJobOutputDownloadRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.jobUuid === null || requestParameters.jobUuid === undefined) {
                            throw new runtime.RequiredError('jobUuid', 'Required parameter requestParameters.jobUuid was null or undefined when calling getJobOutputDownload.');
                        }
                        if (requestParameters.outputPath === null || requestParameters.outputPath === undefined) {
                            throw new runtime.RequiredError('outputPath', 'Required parameter requestParameters.outputPath was null or undefined when calling getJobOutputDownload.');
                        }
                        queryParameters = {};
                        if (requestParameters.compress !== undefined) {
                            queryParameters['compress'] = requestParameters.compress;
                        }
                        if (requestParameters.format !== undefined) {
                            queryParameters['format'] = requestParameters.format;
                        }
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/{jobUuid}/output/download/{outputPath}".replace("{" + "jobUuid" + "}", encodeURIComponent(String(requestParameters.jobUuid))).replace("{" + "outputPath" + "}", encodeURIComponent(String(requestParameters.outputPath))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.BlobApiResponse(response)];
                }
            });
        });
    };
    /**
     * Download job\'s output files for previously submitted job by its UUID. The job must be in a terminal state - FINISHED or FAILED.    The caller must be the job owner, creator or a tenant administrator. The URL must ends with \'/\' even if there is no outputPath is specified.
     */
    JobsApi.prototype.getJobOutputDownload = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJobOutputDownloadRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve job\'s output files list for previously submitted job by its UUID. The job must be in a terminal state (FINISHED or FAILED or CANCELLED)    The caller must be the job owner, creator or a tenant administrator. The URL must ends with \'/\' even if there is no outputPath is specified.
     */
    JobsApi.prototype.getJobOutputListRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.jobUuid === null || requestParameters.jobUuid === undefined) {
                            throw new runtime.RequiredError('jobUuid', 'Required parameter requestParameters.jobUuid was null or undefined when calling getJobOutputList.');
                        }
                        if (requestParameters.outputPath === null || requestParameters.outputPath === undefined) {
                            throw new runtime.RequiredError('outputPath', 'Required parameter requestParameters.outputPath was null or undefined when calling getJobOutputList.');
                        }
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/{jobUuid}/output/list/{outputPath}".replace("{" + "jobUuid" + "}", encodeURIComponent(String(requestParameters.jobUuid))).replace("{" + "outputPath" + "}", encodeURIComponent(String(requestParameters.outputPath))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespGetJobOutputListFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve job\'s output files list for previously submitted job by its UUID. The job must be in a terminal state (FINISHED or FAILED or CANCELLED)    The caller must be the job owner, creator or a tenant administrator. The URL must ends with \'/\' even if there is no outputPath is specified.
     */
    JobsApi.prototype.getJobOutputList = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJobOutputListRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve list of jobs for the user based on search conditions in the query paramter on the dedicated search end-point.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobSearchListRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.startAfter !== undefined) {
                            queryParameters['startAfter'] = requestParameters.startAfter;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.computeTotal !== undefined) {
                            queryParameters['computeTotal'] = requestParameters.computeTotal;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/search",
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespJobSearchAllAttributesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve list of jobs for the user based on search conditions in the query paramter on the dedicated search end-point.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobSearchList = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJobSearchListRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve list of jobs for the user based on search conditions in the request body and pagination information from the query paramter on the dedicated search end-point.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobSearchListByPostSqlStrRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        queryParameters = {};
                        if (requestParameters.limit !== undefined) {
                            queryParameters['limit'] = requestParameters.limit;
                        }
                        if (requestParameters.skip !== undefined) {
                            queryParameters['skip'] = requestParameters.skip;
                        }
                        if (requestParameters.startAfter !== undefined) {
                            queryParameters['startAfter'] = requestParameters.startAfter;
                        }
                        if (requestParameters.orderBy !== undefined) {
                            queryParameters['orderBy'] = requestParameters.orderBy;
                        }
                        if (requestParameters.computeTotal !== undefined) {
                            queryParameters['computeTotal'] = requestParameters.computeTotal;
                        }
                        if (requestParameters.select !== undefined) {
                            queryParameters['select'] = requestParameters.select;
                        }
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/search",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: requestParameters.body,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespJobSearchAllAttributesFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve list of jobs for the user based on search conditions in the request body and pagination information from the query paramter on the dedicated search end-point.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobSearchListByPostSqlStr = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJobSearchListByPostSqlStrRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Retrieve status of a previously submitted job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobStatusRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.jobUuid === null || requestParameters.jobUuid === undefined) {
                            throw new runtime.RequiredError('jobUuid', 'Required parameter requestParameters.jobUuid was null or undefined when calling getJobStatus.');
                        }
                        queryParameters = {};
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/{jobUuid}/status".replace("{" + "jobUuid" + "}", encodeURIComponent(String(requestParameters.jobUuid))),
                                method: 'GET',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespGetJobStatusFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Retrieve status of a previously submitted job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.getJobStatus = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getJobStatusRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Hide a job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.hideJobRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.jobUuid === null || requestParameters.jobUuid === undefined) {
                            throw new runtime.RequiredError('jobUuid', 'Required parameter requestParameters.jobUuid was null or undefined when calling hideJob.');
                        }
                        queryParameters = {};
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/{jobUuid}/hide".replace("{" + "jobUuid" + "}", encodeURIComponent(String(requestParameters.jobUuid))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespHideJobFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Hide a job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.hideJob = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.hideJobRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Resubmit a job for execution using the original parameters.  The main phases of job execution are:    - validate input   - check resource availability   - stage input files   - stage application code   - launch application   - monitor application   - archive application output
     */
    JobsApi.prototype.resubmitJobRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.jobuuid === null || requestParameters.jobuuid === undefined) {
                            throw new runtime.RequiredError('jobuuid', 'Required parameter requestParameters.jobuuid was null or undefined when calling resubmitJob.');
                        }
                        queryParameters = {};
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/{jobuuid}/resubmit".replace("{" + "jobuuid" + "}", encodeURIComponent(String(requestParameters.jobuuid))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespSubmitJobFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Resubmit a job for execution using the original parameters.  The main phases of job execution are:    - validate input   - check resource availability   - stage input files   - stage application code   - launch application   - monitor application   - archive application output
     */
    JobsApi.prototype.resubmitJob = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.resubmitJobRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Submit a job for execution.  The main phases of job execution are:    - validate input   - check resource availability   - stage input files   - stage application code   - launch application   - monitor application   - archive application output
     */
    JobsApi.prototype.submitJobRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.reqSubmitJob === null || requestParameters.reqSubmitJob === undefined) {
                            throw new runtime.RequiredError('reqSubmitJob', 'Required parameter requestParameters.reqSubmitJob was null or undefined when calling submitJob.');
                        }
                        queryParameters = {};
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        headerParameters['Content-Type'] = 'application/json';
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/submit",
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                                body: models_1.ReqSubmitJobToJSON(requestParameters.reqSubmitJob),
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespSubmitJobFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Submit a job for execution.  The main phases of job execution are:    - validate input   - check resource availability   - stage input files   - stage application code   - launch application   - monitor application   - archive application output
     */
    JobsApi.prototype.submitJob = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.submitJobRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * Un-hide a job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.unhideJobRaw = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var queryParameters, headerParameters, response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (requestParameters.jobUuid === null || requestParameters.jobUuid === undefined) {
                            throw new runtime.RequiredError('jobUuid', 'Required parameter requestParameters.jobUuid was null or undefined when calling unhideJob.');
                        }
                        queryParameters = {};
                        if (requestParameters.pretty !== undefined) {
                            queryParameters['pretty'] = requestParameters.pretty;
                        }
                        headerParameters = {};
                        if (this.configuration && this.configuration.apiKey) {
                            headerParameters["X-Tapis-Token"] = this.configuration.apiKey("X-Tapis-Token"); // TapisJWT authentication
                        }
                        return [4 /*yield*/, this.request({
                                path: "/v3/jobs/{jobUuid}/unhide".replace("{" + "jobUuid" + "}", encodeURIComponent(String(requestParameters.jobUuid))),
                                method: 'POST',
                                headers: headerParameters,
                                query: queryParameters,
                            }, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [2 /*return*/, new runtime.JSONApiResponse(response, function (jsonValue) { return models_1.RespHideJobFromJSON(jsonValue); })];
                }
            });
        });
    };
    /**
     * Un-hide a job by its UUID.  The caller must be the job owner, creator or a tenant administrator.
     */
    JobsApi.prototype.unhideJob = function (requestParameters, initOverrides) {
        return __awaiter(this, void 0, void 0, function () {
            var response;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.unhideJobRaw(requestParameters, initOverrides)];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, response.value()];
                    case 2: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    return JobsApi;
}(runtime.BaseAPI));
exports.JobsApi = JobsApi;
